import { supabase } from '../lib/supabase';
import { LEGACY_OPERATOR_ROLE_TYPE, OPERATOR_SUBROLE_TYPES } from '../lib/operatorRoles';

/**
 * Load configured actions for a milestone template (runtime: case detail timeline).
 */
export async function fetchMilestoneTemplateActionsForRuntime(milestoneTemplateId) {
  if (!milestoneTemplateId) return [];
  const { data, error } = await supabase
    .from('milestone_template_actions')
    .select('*')
    .eq('milestone_template_id', milestoneTemplateId)
    .order('sort_order', { ascending: true });
  if (error) {
    console.error('[workflowRuntimeService]', error);
    return [];
  }
  return data || [];
}

/**
 * Étend les rôles autorisés côté workflow : si la config contient encore `operators`, équivalent aux 4 sous-rôles.
 * @param {string} userRole
 * @param {string[]} allowedRoleTypes
 */
function expandWorkflowAllowedRoleTypes(allowedRoleTypes) {
  if (!allowedRoleTypes?.length) return [];
  const out = new Set(allowedRoleTypes);
  if (out.has(LEGACY_OPERATOR_ROLE_TYPE)) {
    out.delete(LEGACY_OPERATOR_ROLE_TYPE);
    OPERATOR_SUBROLE_TYPES.forEach((t) => out.add(t));
  }
  return [...out];
}

/**
 * @param {string} userRole
 * @param {string[]} allowedRoleTypes
 */
export function workflowActionAllowedForRole(userRole, allowedRoleTypes) {
  if (!userRole || !allowedRoleTypes?.length) return false;
  const expanded = expandWorkflowAllowedRoleTypes(allowedRoleTypes);
  return expanded.includes(userRole);
}

/** @param {string | string[] | null | undefined} userRoleOrRoles */
export function normalizeWorkflowUserRoles(userRoleOrRoles) {
  if (Array.isArray(userRoleOrRoles)) {
    return [...new Set(userRoleOrRoles.filter((r) => typeof r === 'string' && r.trim()))];
  }
  if (typeof userRoleOrRoles === 'string' && userRoleOrRoles.trim()) {
    return [userRoleOrRoles];
  }
  return [];
}

/**
 * Vrai si au moins un des rôles utilisateur est autorisé pour l’action workflow.
 * @param {string | string[]} userRoleOrRoles
 * @param {string[]} allowedRoleTypes
 */
export function workflowActionAllowedForAnyRole(userRoleOrRoles, allowedRoleTypes) {
  const roles = normalizeWorkflowUserRoles(userRoleOrRoles);
  if (!roles.length || !allowedRoleTypes?.length) return false;
  return roles.some((r) => workflowActionAllowedForRole(r, allowedRoleTypes));
}
